const allImageCards = document.querySelectorAll<HTMLElement>('.image-card');

const cardHandler = (card: HTMLElement) => {
  const cardInforHeight = card.querySelector('.image-card-info')?.clientHeight;

  if (cardInforHeight) {
    card.style.setProperty('--image-height', `${cardInforHeight}px`);
  }
};

for (const card of allImageCards) {
  cardHandler(card);

  window.addEventListener('resize', () => {
    cardHandler(card);
  });
}
